import React, { useState } from 'react';
import type { MutableRefObject } from 'react';
import type Handsontable from 'handsontable/base';

import FormulaDropdown from './FormulaDropdown';
import type { FormulaDropdownRef } from './FormulaDropdown';
import DatePickerContainer from './cellTypes/DatePickerContainer';

import type { ImMNElement } from '../../../common/elements/elementModelTypes';
import type { MilanoteEditorRef } from '../../components/editor/milanoteEditor/MilanoteEditorTypes';

type TablePopupsProps = {
    element: ImMNElement;
    gridSize: number;
    isCurrentlyEditingTableCell: boolean;
    dropdownRef: MutableRefObject<FormulaDropdownRef | null>;
    cellEditorRef: MutableRefObject<MilanoteEditorRef | null>;
    locale: string;
    hotTableInstanceRef: MutableRefObject<Handsontable | null>;
};

const TablePopups: React.FC<TablePopupsProps> = ({
    element,
    gridSize,
    isCurrentlyEditingTableCell,
    dropdownRef,
    cellEditorRef,
    locale,
    hotTableInstanceRef,
}) => {
    const addFormulaToCell = (formula: string) => {
        if (!formula) return;
        cellEditorRef.current?.setPlainText(`=${formula}(`);
    };

    const [showFormulaDropdown, setShowFormulaDropdown] = useState(false);

    return (
        <>
            <FormulaDropdown
                ref={dropdownRef}
                addFormulaToCell={addFormulaToCell}
                showFormulaDropdown={showFormulaDropdown}
                setShowFormulaDropdown={setShowFormulaDropdown}
            />
            {isCurrentlyEditingTableCell && (
                <DatePickerContainer
                    showFormulaDropdown={showFormulaDropdown}
                    isCurrentlyEditingTableCell={isCurrentlyEditingTableCell}
                    gridSize={gridSize}
                    element={element}
                    cellEditorRef={cellEditorRef}
                    locale={locale}
                    hotTableInstanceRef={hotTableInstanceRef}
                />
            )}
        </>
    );
};

export default TablePopups;
